import marked from 'marked';

const markdown = marked.setOptions({
  sanitize: true,
});

export default (instance: any) => {
  instance.prototype.$markdown = markdown;
  instance.prototype.$formatMessage = (
    message: string,
    value: any,
  ) => markdown(message.replace('%%', value));
};
